// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1BulkHoursImportSchema } from './v1/bulk/hoursImportSchema';
import { v1BulkImportResponseSchema } from './v1/bulk/importResponseSchema';

export const bulkImportHoursPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const bulkImportHoursHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Time entries imported successfully (synchronous)
 */
export const bulkImportHours200Schema = z.lazy(() => v1BulkImportResponseSchema);

/**
 * @description Time entries import accepted (asynchronous for large batches)
 */
export const bulkImportHours202Schema = z.lazy(() => v1BulkImportResponseSchema);

export const bulkImportHoursMutationRequestSchema = z.lazy(() => v1BulkHoursImportSchema);

export const bulkImportHoursMutationResponseSchema = z.lazy(() => bulkImportHours200Schema);
